






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Form } from '@/models/Form';
import { BAlert, BModal } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import { User } from '@/models/User';

@Component({
    name: 'ModalFormDuplicate',
    components: {
        'b-alert': BAlert,
        'b-modal': BModal,
    },
    computed: mapGetters({
        account: 'account/account',
    }),
})
export default class ModalFormDuplicate extends Vue {
    @Prop() form!: Form;

    error: string = '';
    updating: boolean = false;

    // getters
    account!: User;

    duplicate() {
        this.updating = true;

        try {
            this.$store.dispatch('forms/duplicate', { owner: this.account, formData: this.form });
            this.$bvModal.hide(`modalFormDuplicate-${this.form.id}`);
        } catch (e) {
            this.error = e;
        } finally {
            this.updating = false;
        }
    }
}
